import { render, staticRenderFns } from "./classificationManage.vue?vue&type=template&id=20d65353&scoped=true&"
import script from "./classificationManage.vue?vue&type=script&lang=js&"
export * from "./classificationManage.vue?vue&type=script&lang=js&"
import style0 from "./classificationManage.vue?vue&type=style&index=0&id=20d65353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d65353",
  null
  
)

export default component.exports